export enum AdTaskType {
  NO_SAMPLE = 1,
  SAMPLE = 2,
}

export enum AdTaskDetailSource {
  BF2025Ad = "bf2025-ad",
}

export enum AdTaskDetailProductDetailType {
  TEXT = "text",
  IMAGE = "image",
  UL = "ul",
  OL = "ol",
}
